// Packages and components
import React from 'react';
import { Box } from 'grommet';
import { FormNextLink } from 'grommet-icons';
import SHDText from '@ui/Text/SHDText';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';

// Hooks
import { useHistory } from 'react-router-dom';

// Types and interfaces
interface NotReadyToGoProYetProps {
  isEntitledToViewLoading: boolean;
  highlightGameId: string | undefined;
}

export const NotReadyToGoProYet: React.FC<NotReadyToGoProYetProps> = ({
  isEntitledToViewLoading,
  highlightGameId,
}) => {
  const history = useHistory();

  return (
    <SHDThemeOverride full={false}>
      <Box
        className="not-ready-to-go-pro-yet"
        background="gray-50"
        pad={{
          horizontal: 'small',
          top: 'small',
          bottom: 'medium',
        }}
        round="12px"
        skeleton={isEntitledToViewLoading}
        onClick={() => {
          history.push(`/game/${highlightGameId}#highlights`);
        }}
      >
        <Box direction="row" align="center" justify="between">
          <Box>
            <SHDText style="body-semibold" color="black">
              Not ready to go pro yet?
            </SHDText>
            <SHDText style="footnote" color="black-alpha-70">
              Watch the team highlights instead
            </SHDText>
          </Box>

          <Box
            background="white"
            round="100%"
            height="32px"
            width="32px"
            align="center"
            justify="center"
          >
            <FormNextLink color="black" size="18px" />
          </Box>
        </Box>
      </Box>
    </SHDThemeOverride>
  );
};

export default NotReadyToGoProYet;
